module.exports = __webpack_public_path__ + "img/edit-2.8a52b23a.svg";